<template>
  <div class="progress-selector-wrapper" v-bind:style="[transform, active_class]">

    <input type="checkbox" class="progress-selector-indicator ind-2" v-on:click="selectorClicked" :class="selectorClass"></input>

    <div class="progress-selector-content ind-1 border-bg-rollover">
      <div class="p max-96"><slot></slot></div>
      <arrow type="next"></arrow>
    </div>

  </div>
</template>

<script>
  import arrow from '../atoms/arrow'
  import emit_clicked from '../../utils/emit_clicked'
  
  export default {
    props: ['transform', 'index', 'activeindex'],
    data () {
      return {
        selectorClass: ''
      }
    },
    methods: {
      emit_clicked,
      selectorClicked () {
        this.selectorClass = 'checked'
        this.emit_clicked()
      }
    },
    components: {
      'arrow': arrow
    },
    computed: {
      active_class () {
        if (this.index !== this.activeindex) {
          // set to inactive
          return {
            // 'pointer-events': 'none'
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../../styles/variables';

  .max-96 {
    max-width: calc(100% - 96px);
  }
  
  //- progress selector -//

  .progress-selector-wrapper {
    position: relative;
    transition: all $transition-1;
    @media screen and (max-width: $sm-max) {
      transform: none !important;
    }
    // DO NOT put a z-index on this.
  }

  .progress-selector-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    &:hover, &:checked, &.checked {
      + .progress-selector-content {
        opacity: 1;
        border: 1px solid $blue;
        + .crosshair-container {
          opacity: 1;
        }
      }
    }
    // &:checked { // prevent unchecking
      // pointer-events: none;
      // ~ .disable-next-progress-selector {
      //   pointer-events: none; // enable checking next selector
      // }
    // }
  }

  .progress-selector-content {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 72px;
    margin-bottom: 12px;
    border: 1px solid transparent;
    p, .p {
      margin-left: 24px;
    }
    .arrow-container {
      margin-right: 24px;
    }
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      height: auto;
      min-height: 72px;
      padding: 12px;
    }
  }

  // .disable-next-progress-selector {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   margin-top: 72px;
  //   cursor: not-allowed;
  //   width: 100%;
  //   height: 100vh;
  //   opacity: 1;
  //   background: rgba(0, 0, 255, 0.1);
  // }
</style>

<style lang="scss">
  // select arrow brackets outside of scope
  .progress-selector-indicator {
    &:hover + .progress-selector-content {
      // todo -> make this a mixin (reused across progress selector and button.vue)
      .arrow-container {
        .bracket-left {
          transform: translateX(-3px);
        }
        .bracket-right {
          transform: translateX(3px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// progress_selector.vue?8c3081ea